(function (algolia) {
  "use strict";
  var rangeSlider = algolia.externals.widgets.rangeSlider;
  var menu = algolia.externals.widgets.menu;
  var refinementList = algolia.externals.widgets.refinementList;

  var TYPES_TO_WIDGET = {
    slider: { name: "rangeSlider", useDefault: true, widget: rangeSlider },
    menu: { name: "menu", params: { limit: 30 }, widget: menu },
    conjunctive: {
      name: "refinementList",
      params: { operator: "and", limit: 200, sortBy: ["name:asc"]},
      widget: refinementList,
    },
    disjunctive: {
      name: "refinementList",
      params: { operator: "or", limit: 30, sortBy: ["name:asc"] },
      widget: refinementList,
    },
  };

  var sortByRefined = function sortByRefined(sortFunction) {
    return function (a, b) {
      if (a.refined !== b.refined) {
        if (a.refined) {
          return -1;
        }
        if (b.refined) {
          return 1;
        }
      }
      return sortFunction(a, b);
    };
  };

  /*
   * Sorting functions : Allows to chose in which order you want to display the facets
   * Algolia will always send you back the most relevant values for each facet (the ones
   * with the highest count). These sorting functions won't change which results come back
   * but how they are displayed. To retrieve more results, change the maxValuesPerFacet
   * parameter in your Algolia Dashboard.
   * The default sort function is refined > count > name.
   */
  algolia.facetSortFunctions = {
    price_range: sortByRefined(function sortRanges(a, b) {
      if (a.name.length === b.name.length) {
        return a.name.localeCompare(b.name);
      }
      return a.name.length - b.name.length;
    }),
  
  };

  /*
   * Display functions
   * When the object sent back for a facet item doesn't match how you would want it to look
   * like, use a function to reformat it how you want.
   */
  algolia.facetDisplayFunctions = {
    price_range: function displayRange(value) {
      var values = value.split(":");

      return values
        .map(function (e) {
          return algolia.formatMoney(Number(e) * 100).replace(/\.\d+/, "");
        })
        .join(" - ");
    },
  };

  algolia.facetCssClasses = {
    root: "ais-facet",
    header: "ais-facet--header",
    body: "ais-facet--body",
    item: "ais-facet--item",
    label: "ais-facet--label",
    checkbox: "ais-facet--checkbox",
    active: "ais-facet--active",
    count: "ais-facet--count",
  };

  var enabledFacets = algolia.config.facets.filter(function (facet) {
    return facet.enabled || parseInt(facet.enabled, 10);
  });
  algolia.facets = enabledFacets.map(function (facet) {
    return algolia.assign({}, facet, {
      escapedName: encodeURIComponent(facet.name),
    });
  });
  algolia.shownFacets = algolia.facets.filter(function (facet) {
    return facet.type !== "hidden";
  });
  algolia.hiddenFacets = algolia.config.facets.filter(function (facet) {
    return facet.type === "hidden";
  });

  function capitalize(stringToCapitalize)
  {
      return stringToCapitalize[0].toUpperCase() + stringToCapitalize.slice(1);
  }

  var facetToWidget = function (facet) {
    var widget = TYPES_TO_WIDGET[facet.type];
    var params = algolia.assign({}, widget.params);

    params.container =
      "[class~='ais-facet-" + facet.escapedName + "-container']";
    params.attribute = facet.name;
    params.templates = {};
    params.cssClasses = algolia.facetCssClasses;

    /**
     * Providing a custom "Show more" template to confirm to the custom
     * Hogan delimiter
     */
    params.templates.showMoreText = algolia.getTemplate(
      "instant_search_facet_show_more"
    );

    if (facet.searchable) {
      params.searchable = true;
      params.searchablePlaceholder = "Search for " + facet.title;
      params.templates.searchableNoResults =
        "<div> No matching for " + facet.title + "</div>";
    }

    params.templates.header = function () {
      return facet.title;
    };

    if (!widget.useDefault) {
      params.templates.item = algolia.getTemplate("instant_search_facet_item");
    }

    if (algolia.facetSortFunctions[facet.name]) {
      params.sortBy = algolia.facetSortFunctions[facet.name];
    }

    const colors_value = `black: #272727,
purple: #8B348F,
violet: #5F499DD,
blue: #383F9F,
light blue: #55B6E4,
turquoise: #41C1C4,
green: #168555,
lime: #CCDB38,
yellow: #FEEA3B,
orange: #F87438,
red: #F34135,
brown: #6F4133,
white: #FAFAFA,
off white: #F0E6DC,
pink: #E93D81,
pastel: #f8caca,
ivory: #F0E6DC,
anthracite mix: #464C61,
anthracite: #464C61,
beige mélangé: #978374,
beige melangé: #978374,
beige melange: #978374,
gold: #CE9227,
beige: #F0DECB,
stone: #D2D1C3,
anthracite mélangé: #464C61,
anthracite melangé: #464C61,
anthracite melange: #464C61,
heather light grey: #8B8987,
light yellow: #FEEA97,
camel: #AD6B4A,
mint: #41C1A6,
lila: #A796B4,
anthracite reps: #858693,
grey mélangé: #97928C,
grey melangé: #97928C,
grey melange: #97928C,
grey: #787878,
burgundy: #922B55,
neutral: #dcc8af,
khaki: #9a9872,
neon: #ccdb38,
metallic: linear-gradient(black white)`;
    const colors_value_array = colors_value.replaceAll("\n", "").split(",");

    const objColors = {};
    colors_value_array.forEach((string) => {
      let [key, value] = string.split(":");
       if(key == 'metallic'){
         value = 'linear-gradient(black, white)' 
        }
      objColors[key] = value.trim();
     
    });
    var displayFunction = algolia.facetDisplayFunctions[facet.name];
    params.transformItems = function (items) {
      if(items.length){
        $(`.ais-facet-${facet.title}`).parent().show()
      }
        return items.map(function (item) {
        var transformedItem = algolia.assign({}, item);
        transformedItem.type = {};
        transformedItem.type[facet.type] = true;
        transformedItem.label = displayFunction
          ? displayFunction(item.value)
          : capitalize(item.value);

        if (facet.title == "colour") {
          let colourCode = "";
          const transformedColour = transformedItem.label.toLowerCase();
          if (transformedColour in objColors) {
            colourCode = objColors[transformedColour];
          }
          transformedItem.label = `<a class="options-color" title=${transformedColour} style="background:${colourCode}">${transformedColour}</a>`;
        }

        return transformedItem;
      });
    };

    return {
      name: widget.name,
      params: params,
      widget: widget.widget,
    };
  };

  // try to fetch facets for current collection or fallback to collections default
  var collection_facets =
    algolia.current_collection_id &&
    algolia.config.collection_facets &&
    algolia.config.collection_facets[algolia.current_collection_id]
      ? algolia.config.collection_facets[algolia.current_collection_id]
      : algolia.config.collection_facets &&
        algolia.config.collection_facets.default;

  if (collection_facets) {
    var enabledCollectionFacets = collection_facets.filter(function (facet) {
      return facet.enabled || parseInt(facet.enabled, 10);
    });

    algolia.collectionFacets = enabledCollectionFacets.map(function (facet) {
      return algolia.assign({}, facet, {
        escapedName: encodeURIComponent(facet.title),
        escapedNameDecoded: facet.title,
      });
    });
    algolia.collectionShownFacets = algolia.collectionFacets.filter(function (
      facet
    ) {
      return facet.type !== "hidden";
    });
    algolia.collectionHiddenFacets = collection_facets.filter(function (facet) {
      return facet.type === "hidden";
    });
    algolia.collectionFacetsWidgets =
      algolia.collectionShownFacets.map(facetToWidget);
  }
  algolia.facetsWidgets = algolia.shownFacets.map(facetToWidget);
})(window.algoliaShopify);
